import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
    selector: 'resident-notifications-filter',
    templateUrl: './resident-notifications-filter.component.html',
    styleUrls: ['./resident-notifications-filter.component.scss']
})
export class ResidentNotificationsFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('unreadCheckbox')  unread:  ElementRef;

    constructor(
        private urlService: UrlService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        const unreadValue = this.urlService.queryParams['only_unread'];
        if (unreadValue)
            this.unread.nativeElement.checked  = unreadValue;
    }

    changeFilter() {
        if(this.unread.nativeElement.checked)
            this.urlService.queryParams['only_unread'] = '1';
        else
            this.urlService.queryParams['only_unread'] = null;

        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('.resident-notifications-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/email-merge/resident-notifications-filter/resident-notifications-filter.component.ts